import React from 'react'
import { Section } from '@shared/components/section'

import { StepsNoSection } from '../steps'

import styles from './style.module.scss'

interface Props {
	title?: string
	steps?: string[]
}

const stepStyles = [styles.stepOne, styles.stepTwo, styles.stepTree]
export const View = ({ steps, title }: Props) => {
	const stepsWithStyles = steps!.map((stepText, idx) => [stepText, stepStyles[idx]])
	return (
		<Section className={styles.wrapper}>
			{title && <h2 className={styles.sectionTitle}>{title}</h2>}
			<StepsNoSection steps={stepsWithStyles} />
		</Section>
	)
}
